import { EmailAuthProvider } from 'firebase/auth';
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyDeX3qc3Rx_otux7Lkw0-9s0DCit80oQjg",
  authDomain: "hpair-portal-95a4f.firebaseapp.com",
  projectId: "hpair-portal-95a4f",
  storageBucket: "hpair-portal-95a4f.appspot.com",
  messagingSenderId: "756263551416",
  appId: "1:756263551416:web:07b4274b5bf6fe20888f4d",
  measurementId: "G-8PY0ZF2HL3"
};

// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);

// Export the auth and firestore services
export const db = app.firestore();
export const auth = app.auth();

// Reauthentication function
async function reauthenticateWithPassword(oldPassword: string): Promise<any> {
  if(auth.currentUser && auth.currentUser.email){
    const credentials = EmailAuthProvider.credential(auth.currentUser.email, oldPassword); 
    await auth.currentUser.reauthenticateWithCredential(credentials);
    return credentials;
  }
}

// Password update function
async function updatePassword(newPassword : string) : Promise<void> {
  if(auth.currentUser){
    await auth.currentUser.updatePassword(newPassword);
  }
}

// Send verification email function
async function sendVerificationEmail() {
  if(auth.currentUser){
    await auth.currentUser.sendEmailVerification();
  }
}

// Update on verify email
async function updateOnVerifyEmail(password: string, newEmail: string): Promise<void> {
  if (auth.currentUser) {
    // Verify before updating
    await reauthenticateWithPassword(password);
    
    // Check if the new email is different from the current email
    if (newEmail === auth.currentUser.email) {
      throw new Error('New email matches current email.', );
    }

    try {
      // Attempt to update email address
      await auth.currentUser.verifyBeforeUpdateEmail(newEmail);
    } catch (error) {
      // Handle error
      console.error('Error updating email:', error);
      throw error;
    }
  }
}

// Refresh user function
// This function is used to refresh the user's ID token to update the user's claims (permissions)
export async function refreshUser() {
  if(auth.currentUser){
    await auth.currentUser.getIdToken(true);
  }
}

export const useAuth = () => {
  return { reauthenticateWithPassword, updatePassword, sendVerificationEmail, updateOnVerifyEmail };
}